import { __generator } from "tslib";
import { all, put, select } from 'redux-saga/effects';
import groupBy from 'lodash/groupBy';
import { selectors, withOffset } from '../../Stream';
import { GALLECTIONS_PER_FETCH, MEDIA_POPUP_GALLECTION_STREAM_GROUP, } from '../constants';
import { getGallectionStreamId } from '../helpers';
import { getMode, getCurrentMediaSource } from '../selectors';
import { MediaPopupMode, } from '../types';
import { normalizeGallections } from '../../redux/normalizr/helpers';
export function getStreamInitAction(mediaSource, folderId, gallectionFolders) {
    if (gallectionFolders === void 0) { gallectionFolders = []; }
    var streamId = getGallectionStreamId(mediaSource, folderId);
    var normalizedGallections = normalizeGallections(gallectionFolders);
    var streamParams = { mediaSource: mediaSource };
    return withOffset.actions.initialize({
        streamId: streamId,
        groupId: MEDIA_POPUP_GALLECTION_STREAM_GROUP,
        streamParams: streamParams,
        itemsPerFetch: GALLECTIONS_PER_FETCH,
        hasMore: !gallectionFolders,
        items: normalizedGallections && normalizedGallections.result,
        entities: normalizedGallections && normalizedGallections.entities,
    });
}
function handleInitGallectionStream(action) {
    var mediaSource, gallectionFolders, streamId, mode, isStreamInitialized, cacheStreams, foldersByParentId_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getCurrentMediaSource)];
            case 1:
                mediaSource = _a.sent();
                if (!mediaSource) {
                    return [2 /*return*/];
                }
                gallectionFolders = action.payload && action.payload.gallectionFolders;
                streamId = getGallectionStreamId(mediaSource);
                return [4 /*yield*/, select(getMode)];
            case 2:
                mode = _a.sent();
                return [4 /*yield*/, select(selectors.isInitialized, streamId)];
            case 3:
                isStreamInitialized = _a.sent();
                cacheStreams = true;
                if (mode === MediaPopupMode.MANAGER) {
                    cacheStreams = false;
                }
                if (isStreamInitialized && cacheStreams) {
                    return [2 /*return*/];
                }
                if (!(gallectionFolders && gallectionFolders.length)) return [3 /*break*/, 5];
                foldersByParentId_1 = groupBy(gallectionFolders || [], 'parentId');
                return [4 /*yield*/, all(Object.keys(foldersByParentId_1)
                        .filter(function (parentId) { return +parentId; })
                        .map(function (parentId) {
                        var folders = foldersByParentId_1[parentId];
                        return put(getStreamInitAction(mediaSource, +parentId, folders));
                    }))];
            case 4:
                _a.sent();
                return [3 /*break*/, 7];
            case 5: return [4 /*yield*/, put(getStreamInitAction(mediaSource, undefined, []))];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7:
                if (!!gallectionFolders) return [3 /*break*/, 9];
                return [4 /*yield*/, put(withOffset.actions.fetch(streamId))];
            case 8:
                _a.sent();
                _a.label = 9;
            case 9: return [2 /*return*/];
        }
    });
}
export default handleInitGallectionStream;
//# sourceMappingURL=initGallectionStream.js.map